import { useCallback } from 'react';

import { AuthManager } from '@store/AuthManager';
import { JwtExpiredError } from '@utils/errors';
import { url } from '@utils/pages';
import { useHistory, useLocation } from 'react-router-dom';
import { BadResponse, StatusNotHandled } from 'tyrann-io';

export const useCallApi = <F extends (...args: any[]) => any>(call: F, key?: unknown): F => {
  const history = useHistory();
  const location = useLocation();

  const handleUnauthorised = useCallback((pathname: string) => {
    console.warn(pathname, 'API is not authorised. ');

    if (AuthManager.shared.isLoggingOut) {
      return;
    }

    if (pathname.startsWith('/admin')) {
      history.push(url('/NotAuthorized'));
    } else {
      console.info(pathname);
      if (!pathname.startsWith('/auth/Login') && !window.location.href.includes('/auth/Login')) {
        history.push(`/auth/Login?fromUrl=${encodeURIComponent(window.location.href)}`);
      }
      AuthManager.shared.clear();
    }
  }, []);

  return (async (...args: Parameters<F>) => {
    const { pathname } = location;

    try {
      const r = await call(...args);
      return r;
    } catch (e) {
      if (e instanceof StatusNotHandled) {
        if ([401, 403].includes(e.status)) {
          handleUnauthorised(pathname);
        }
        console.error(`StatusNotHandled: ${JSON.stringify(key)}\n`, e.request, e.response);
      }

      if (e instanceof JwtExpiredError) {
        console.error('JwtExpiredError');
        handleUnauthorised(pathname);
      }

      if (e instanceof BadResponse) {
        const { errors } = e;
        // Can't access default.reporter
        const { reporter } = await import('io-ts-reporters');
        const messages = reporter(errors);

        console.error(`BadResponse: ${JSON.stringify(key)}\n ${messages.join('\n')}`);
        console.error(`BadResponse: original errors:`, errors);
      }

      throw e;
    }
  }) as F;
};
